/**
 * Owner: Masa Bayu
 * File: qxcircle-follow-action.ts
 * Date:Time: 2026-09-18 11:11
 * Description: QXCircle follow toggle — reject self via session handle.
 */

import { BadRequestException, NotFoundException } from './_nestjs-common';
import { createFollowNotification } from './qxcircle-follow-notification';
import { normalizeQxCircleAuthorHandle } from './qxcircle-service-helpers';
import type {
  QxCircleFeedPost,
  QxCircleFollowResult,
  QxCircleNotification,
} from './qxcircle.types';

export function toggleQxCircleFollowAuthor(
  handleRaw: string,
  posts: QxCircleFeedPost[],
  localFollows: Set<string>,
  ntfSeq: number,
  viewerHandle: string | null = null,
): {
  result: QxCircleFollowResult;
  notification: QxCircleNotification | null;
  nextSeq: number;
} {
  const authorHandle = normalizeQxCircleAuthorHandle(handleRaw);
  if (viewerHandle && authorHandle === viewerHandle) {
    throw new BadRequestException('Cannot follow yourself');
  }
  const authorPost = posts.find((p) => p.authorHandle === authorHandle);
  if (!authorPost) {
    throw new NotFoundException(`Author not found: ${authorHandle}`);
  }
  if (localFollows.has(authorHandle)) {
    localFollows.delete(authorHandle);
  } else {
    localFollows.add(authorHandle);
  }
  const followedByLocal = localFollows.has(authorHandle);
  let notification: QxCircleNotification | null = null;
  let nextSeq = ntfSeq;
  if (followedByLocal) {
    nextSeq += 1;
    notification = createFollowNotification(
      nextSeq,
      authorPost.authorName,
      authorHandle,
    );
  }
  return {
    nextSeq,
    notification,
    result: {
      authorHandle,
      authorName: authorPost.authorName,
      followedByLocal,
      note: followedByLocal
        ? 'Following — local notification simulated (not push prod)'
        : 'Unfollowed',
    },
  };
}
